export function hadithProviderLabel(provider:string|undefined|null){
 const value=String(provider||'').trim()
 if(value==='quran-foundation')return 'Quran Foundation'
 if(value==='fawazahmed0-hadith-api')return 'fawazahmed0/hadith-api'
 if(value==='sunnah_com')return 'Sunnah.com'
 if(value==='qirtaas')return 'Qirtaas'
 if(value==='manual')return 'Manually entered'
 return value||'Provider not recorded'
}
